<template>
  <div :id="'project-inq'+projectIdx" class="dvClientFormBox">
    <div class="dvClientFormBox-header valign-wrapper">
      <div class="dvClientFormBox-header-title">
        Project Inquiry {{ projectsCnt > 1 ? projectIdx + 1 : '' }}
      </div>
      <a
        @click="confirm({
          id: projectInquiryDetails.id,
          idx: projectIdx,
          type: 'remove-project-inq'
        })"
        v-if="projectsCnt > 1"
        href="javascript:void(0)" class="dvClientFormBox-header-btn btn waves-effect waves-light flexCenterAll">remove <span class="icon-action_close"></span></a>
    </div>

    <div class="dvClientFormBox-content">
      <div class="row">
        <form class="col s12">
          <div class="row">
            <div class="col l4 m12 s12">
              <div class="dvClientFormBox-content-item">
                <input type="hidden" v-model="projectInquiryDetails.id">
                <v-select
                  v-model="projectInquiryDetails.project_interested_in"
                  @change="projectChange"
                  :items="projectData.projects"
                  menu-props="auto"
                  label="Project Interested In"
                  placeholder="Select a Project"
                  prepend-icon="icon-content_project"
                  item-text="name"
                  item-value="id"
                  required>
                </v-select>
              </div><!-- dvClientFormBox-content-item -->
            </div><!-- col -->

            <div class="col l4 m12 s12">
              <div class="dvClientFormBox-content-item">
                <v-select
                  v-model="projectInquiryDetails.project_location"
                  @change="locationChange"
                  menu-props="auto"
                  :items="projectData.projectLocations"
                  label="Select Location"
                  placeholder="Project Location"
                  prepend-icon="icon-content_location"
                  item-text="name"
                  item-value="id"
                  required>
                </v-select>
              </div><!-- dvClientFormBox-content-item -->
            </div><!-- col -->            

          </div><!-- row -->
        </form><!-- form -->
      </div><!-- row -->
    </div><!-- dvClientFormBox-content -->
  </div> <!-- dvClientFormBox -->
</template>

<script>
  export default {
    name: 'project-info',
    props: ['projectIdx', 'projectsCnt', 'projectInquiryDetails', 'projectData'],
    data: () => ({
    }),
    methods: {
      confirm (action){
        this.$emit('confirm', action)
      },
      getProjectName: function(id){
        return this.projectData.projects.filter(project => {
          return project.id == id
        })
      },
      projectChange (val){
        let project = this.getProjectName(val);
        this.projectInquiryDetails.property_type = project[0].project_type_id
        this.projectInquiryDetails.project_location = project[0].location_id
      },
      propertyTypeChange (val){
        this.projectInquiryDetails.project_interested_in = ''
      },
      locationChange (val){
        this.projectInquiryDetails.project_interested_in = ''
      }
    },
    mounted() {
    }
  }
</script>
